import React, { PropTypes } from 'react';
import Dropdown from 'modules/common/components/Dropdown';
import cx from 'classnames';

const renderDefault = placeholder => (
  <div className="default text">{placeholder}</div>
);

const renderItem = name => item => (
  <div key={name + '_' + item.key} data-value={item.key} className="item">
    {item.name}
  </div>
);

const onChangeSelection = (onChange, singleChoice) => {
  return selection => {
    if (singleChoice) {
      onChange(selection);
    } else {
      const values = selection.split(',').filter(v => v.length > 0);
      onChange(values);
    }
  };
};

export default class Choices extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    items: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    singleChoice: PropTypes.bool.isRequired,
  };

  render() {
    const {
      items,
      name,
      onChange,
      placeholder,
      label,
      singleChoice,
    } = this.props;
    const renderPlaceholder = () => renderDefault(placeholder);

    const dropdownClasses = cx('', {
      multiple: !singleChoice,
      fluid: !singleChoice,
      search: !singleChoice,
    });

    return (
      <div className="ui field">
        <label>{label}</label>
        <Dropdown
          name={name}
          className={dropdownClasses}
          canDelete={singleChoice}
          items={items}
          renderDefault={renderPlaceholder}
          renderItem={renderItem(name)}
          onChange={onChangeSelection(onChange, singleChoice)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/Choices.js